<template>
  <div class="Echarts">
    <div :id="chart.idName" style="width:100%; height: 440px;background-color:#FFFFFF;box-sizing:border-box;padding:20px 20px 0; border-radius: 10px;"></div>
  </div>
</template>

<script>
  export default {
    props:["chart"],
    data(){
      return{
        day:[],
        day2:[220, 182, 191, 234, 290, 330, 310],
        day3:[150, 232, 201, 154, 190, 330, 410],
      }
    },
    mounted() {
      // this.init()
    },
    methods: {
      init() {
        httpKit.post($api_eap.user.get).then(res => {
          if (res.data.code === '200') {
            this.day = [
              res.data.data.memberWeekChart.day1.personalMemberDayCount,
              res.data.data.memberWeekChart.day2.personalMemberDayCount,
              res.data.data.memberWeekChart.day3.personalMemberDayCount,
              res.data.data.memberWeekChart.day4.personalMemberDayCount,
              res.data.data.memberWeekChart.day5.personalMemberDayCount,
              res.data.data.memberWeekChart.day6.personalMemberDayCount,
              res.data.data.memberWeekChart.day7.personalMemberDayCount,
            ];
            this.day2 = [
              res.data.data.memberWeekChart.day1.companyMemberDayCount,
              res.data.data.memberWeekChart.day2.companyMemberDayCount,
              res.data.data.memberWeekChart.day3.companyMemberDayCount,
              res.data.data.memberWeekChart.day4.companyMemberDayCount,
              res.data.data.memberWeekChart.day5.companyMemberDayCount,
              res.data.data.memberWeekChart.day6.companyMemberDayCount,
              res.data.data.memberWeekChart.day7.companyMemberDayCount,
            ];
            this.day3 = [
              res.data.data.memberWeekChart.day1.organizationMemberDayCount,
              res.data.data.memberWeekChart.day2.organizationMemberDayCount,
              res.data.data.memberWeekChart.day3.organizationMemberDayCount,
              res.data.data.memberWeekChart.day4.organizationMemberDayCount,
              res.data.data.memberWeekChart.day5.organizationMemberDayCount,
              res.data.data.memberWeekChart.day6.organizationMemberDayCount,
              res.data.data.memberWeekChart.day7.organizationMemberDayCount,
            ];

            this.$nextTick(() => {
              this.myEcharts(this.day, this.day2, this.day3)
            });
          }
        })
      },
      myEcharts(value1, value2, value3) {
        // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById(this.chart.idName));

        // 指定图表的配置项和数据
        let option = {
          title: {
            text: this.chart.title
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          // legend: {
          //     data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
          // },
          toolbox: {
            feature: {
              saveAsImage: {}
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              name: '个人',
              type: 'line',
              stack: 'Total',
              areaStyle: {},
              emphasis: {
                focus: 'series'
              },
              data: value1,
              color: 'skyblue'
            },
            {
              name: '企业',
              type: 'line',
              stack: 'Total',
              areaStyle: {},
              emphasis: {
                focus: 'series'
              },
              data: value2,
              color: 'hotpink'
            },
            {
              name: '机构',
              type: 'line',
              stack: 'Total',
              areaStyle: {},
              emphasis: {
                focus: 'series'
              },
              data: value3,
              color: 'lightgreen'
            }
          ]
        };

        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);
        myChart.resize()
      }
    }
  }
</script>

<style lang="less" scoped>
  .Echarts{
    box-sizing: border-box;
    margin:10px 0;
    width:calc((100% - 60px)/2);
  }
</style>
